/* goody-ge-twinlang-fr-en-es.js
   GOODY "MES ÉCRITS" — TwinLang FR/EN/ES
   - Multi-instances Shopify-safe
   - Suit la langue du navigateur / pays (html[lang] puis navigator.language)
   - Fallback : toute langue "famille EN" => EN ; "famille ES" => ES ; sinon FR
   - Empêche la traduction automatique du navigateur sur ce bloc (translate="no")
   - API globale: window.GoodyGETwinLang
   - Auto-sync: écoute languagechange (si supporté) + polling léger
*/
(function () {
  "use strict";

  // --- Helpers ---
  function normLang(raw) {
    var s = String(raw || "").toLowerCase();
    // famille anglophone
    if (s.indexOf("en") === 0) return "en";
    // famille hispanophone
    if (s.indexOf("es") === 0) return "es";
    // tout le reste => canon FR
    return "fr";
  }

  function getDocLang() {
    var htmlLang = document.documentElement.getAttribute("lang");
    if (htmlLang) return normLang(htmlLang);
    var nav = (navigator.languages && navigator.languages[0]) || navigator.language || "fr";
    return normLang(nav);
  }

  // Marqueur “NE PAS TRADUIRE”
  function NT(text, lang) {
    var lg = lang || "gcf";
    return '<span class="ge-notranslate" translate="no" lang="' + lg + '">' + text + "</span>";
  }

  // Applique translate="no" au bloc + modal
  function lockAutoTranslate(root, lang) {
    try {
      root.setAttribute("translate", "no");
      root.setAttribute("lang", lang);
      var modal = root.querySelector("[data-ge-modal]");
      if (modal) {
        modal.setAttribute("translate", "no");
        modal.setAttribute("lang", lang);
      }
    } catch (_) {}
  }

  // --- Termes verrouillés (si besoin) ---
  // Ici, surtout des titres/termes à garder stables :
  var LOCK = {
    mi_peyila: NT("MI Péyi-la", "gcf"),
    rezonans: NT("RéZonans", "gcf"),
    calameo: NT("Calaméo", "fr"),
    linkedin: NT("LinkedIn", "en"),
    youtube: NT("YouTube", "en"),
    soundcloud: NT("SoundCloud", "en")
  };

  // --- Liens (identiques dans toutes les langues) ---
  var LINKS = {
    publications: "https://www.calameo.com/goody/read/002667282661d137f2f55",
    newsletter: "https://www.linkedin.com/newsletters/7047475165948964866/?displayConfirmation=true",

    cat_mipeyila: "https://www.calameo.com/goody/read/002667282832ae9f9a3f5",
    cat_rezonans: "https://www.calameo.com/goody/read/00266728248cb5e3d2fd4",
    cat_general2017: "https://www.calameo.com/goody/read/002667282ed2bb7a8de6d",
    cat_2001_2010: "https://www.calameo.com/goody/read/0026672825db7bed5c2af",

    reportages: "https://www.calameo.com/goody/read/0026672820f0c1af1000d",

    youtube: "https://youtube.com/@gilleseugene115?si=KlCq1HN8XX0_yWZg",
    soundcloud: "https://soundcloud.com/gilles-eugene?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing",

    pensees: "https://goodyart.store/blogs/pensees"
  };

  // --- UI (boutons + fermer) ---
  var UI = {
    fr: {
      buttons: {
        publications: "Publications",
        newsletter: "Newsletter (LinkedIn)",
        catalogues: "Catalogues",
        videos: "Vidéos & audios",
        pensees: "Pensées"
      },
      close: "Fermer",
      link_label: "ICI"
    },
    en: {
      buttons: {
        publications: "Publications",
        newsletter: "Newsletter (LinkedIn)",
        catalogues: "Catalogs",
        videos: "Videos & audio",
        pensees: "Thoughts"
      },
      close: "Close",
      link_label: "HERE"
    },
    es: {
      buttons: {
        publications: "Publicaciones",
        newsletter: "Boletín (LinkedIn)",
        catalogues: "Catálogos",
        videos: "Vídeos y audios",
        pensees: "Pensamientos"
      },
      close: "Cerrar",
      link_label: "AQUÍ"
    }
  };

  // --- Contenus trilingues ---
  var CONTENT = {
    publications: {
      fr: {
        title: "Publications",
        html:
          '<p class="ge-tagline">Magazines, revues et sites : ressources et publications autour du travail.</p>' +
          "<h4>Lien</h4>" +
          "<ul>" +
          '<li><strong>Publications</strong> — <a href="' + LINKS.publications + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>"
      },
      en: {
        title: "Publications",
        html:
          '<p class="ge-tagline">Magazines, journals and websites: resources and publications around the work.</p>' +
          "<h4>Link</h4>" +
          "<ul>" +
          '<li><strong>Publications</strong> — <a href="' + LINKS.publications + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>"
      },
      es: {
        title: "Publicaciones",
        html:
          '<p class="ge-tagline">Revistas, sitios y recursos: publicaciones en torno al trabajo.</p>' +
          "<h4>Enlace</h4>" +
          "<ul>" +
          '<li><strong>Publicaciones</strong> — <a href="' + LINKS.publications + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>"
      }
    },

    newsletter: {
      fr: {
        title: "Newsletter (LinkedIn)",
        html:
          '<p class="ge-tagline">Newsletter : écrits publiés et rendez-vous éditoriaux.</p>' +
          "<h4>Lien</h4>" +
          "<ul>" +
          '<li><strong>Newsletter</strong> — <a href="' + LINKS.newsletter + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>"
      },
      en: {
        title: "Newsletter (LinkedIn)",
        html:
          '<p class="ge-tagline">Newsletter: published texts and editorial updates.</p>' +
          "<h4>Link</h4>" +
          "<ul>" +
          '<li><strong>Newsletter</strong> — <a href="' + LINKS.newsletter + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>"
      },
      es: {
        title: "Boletín (LinkedIn)",
        html:
          '<p class="ge-tagline">Boletín: textos publicados y citas editoriales.</p>' +
          "<h4>Enlace</h4>" +
          "<ul>" +
          '<li><strong>Boletín</strong> — <a href="' + LINKS.newsletter + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>"
      }
    },

    catalogues: {
      fr: {
        title: "Catalogues",
        html:
          '<p class="ge-tagline">Catalogues et documents : archives, séries, expositions.</p>' +
          "<h4>Catalogues (" + LOCK.calameo + ")</h4>" +
          "<ul>" +
          '<li><strong>' + LOCK.mi_peyila + "</strong> — Catalogue de l’exposition (2022) — " +
          '<a href="' + LINKS.cat_mipeyila + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          '<li><strong>' + LOCK.rezonans + "</strong> — Catalogue de l’exposition (2019) — " +
          '<a href="' + LINKS.cat_rezonans + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          '<li><strong>Catalogue général</strong> — 2017 — ' +
          '<a href="' + LINKS.cat_general2017 + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          '<li><strong>Catalogue 2001–2010</strong> — ' +
          '<a href="' + LINKS.cat_2001_2010 + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>"
      },
      en: {
        title: "Catalogs",
        html:
          '<p class="ge-tagline">Catalogs and documents: archives, series, exhibitions.</p>' +
          "<h4>Catalogs (" + LOCK.calameo + ")</h4>" +
          "<ul>" +
          '<li><strong>' + LOCK.mi_peyila + "</strong> — Exhibition catalog (2022) — " +
          '<a href="' + LINKS.cat_mipeyila + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          '<li><strong>' + LOCK.rezonans + "</strong> — Exhibition catalog (2019) — " +
          '<a href="' + LINKS.cat_rezonans + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          '<li><strong>General catalog</strong> — 2017 — ' +
          '<a href="' + LINKS.cat_general2017 + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          '<li><strong>Catalog 2001–2010</strong> — ' +
          '<a href="' + LINKS.cat_2001_2010 + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>"
      },
      es: {
        title: "Catálogos",
        html:
          '<p class="ge-tagline">Catálogos y documentos: archivos, series, exposiciones.</p>' +
          "<h4>Catálogos (" + LOCK.calameo + ")</h4>" +
          "<ul>" +
          '<li><strong>' + LOCK.mi_peyila + "</strong> — Catálogo de la exposición (2022) — " +
          '<a href="' + LINKS.cat_mipeyila + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          '<li><strong>' + LOCK.rezonans + "</strong> — Catálogo de la exposición (2019) — " +
          '<a href="' + LINKS.cat_rezonans + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          '<li><strong>Catálogo general</strong> — 2017 — ' +
          '<a href="' + LINKS.cat_general2017 + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          '<li><strong>Catálogo 2001–2010</strong> — ' +
          '<a href="' + LINKS.cat_2001_2010 + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>"
      }
    },

    videos: {
      fr: {
        title: "Vidéos & audios",
        html:
          '<p class="ge-tagline">Vidéos, audios, reportages et émissions : entretiens, contenus, archives.</p>' +
          "<h4>Chaînes</h4>" +
          "<ul>" +
          "<li><strong>Chaîne " + LOCK.youtube + "</strong> — " +
          '<a href="' + LINKS.youtube + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "<li><strong>Chaîne " + LOCK.soundcloud + "</strong> — " +
          '<a href="' + LINKS.soundcloud + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>" +
          "<h4>Reportages & émissions</h4>" +
          "<ul>" +
          '<li><strong>Reportages & émissions</strong> — <a href="' + LINKS.reportages + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>"
      },
      en: {
        title: "Videos & audio",
        html:
          '<p class="ge-tagline">Videos, audio, reports and shows: interviews, content, archives.</p>' +
          "<h4>Channels</h4>" +
          "<ul>" +
          "<li><strong>" + LOCK.youtube + " channel</strong> — " +
          '<a href="' + LINKS.youtube + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "<li><strong>" + LOCK.soundcloud + " channel</strong> — " +
          '<a href="' + LINKS.soundcloud + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>" +
          "<h4>Reports & shows</h4>" +
          "<ul>" +
          '<li><strong>Reports & shows</strong> — <a href="' + LINKS.reportages + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>"
      },
      es: {
        title: "Vídeos y audios",
        html:
          '<p class="ge-tagline">Vídeos, audios, reportajes y emisiones: entrevistas, contenidos, archivos.</p>' +
          "<h4>Canales</h4>" +
          "<ul>" +
          "<li><strong>Canal " + LOCK.youtube + "</strong> — " +
          '<a href="' + LINKS.youtube + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "<li><strong>Canal " + LOCK.soundcloud + "</strong> — " +
          '<a href="' + LINKS.soundcloud + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>" +
          "<h4>Reportajes y emisiones</h4>" +
          "<ul>" +
          '<li><strong>Reportajes y emisiones</strong> — <a href="' + LINKS.reportages + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>"
      }
    },

    pensees: {
      fr: {
        title: "Pensées",
        html:
          '<p class="ge-tagline">Textes et discussions : notes, prises de parole et fragments.</p>' +
          "<h4>Lien</h4>" +
          "<ul>" +
          '<li><strong>Pensées</strong> — <a href="' + LINKS.pensees + '" target="_blank" rel="noopener">' + UI.fr.link_label + "</a></li>" +
          "</ul>"
      },
      en: {
        title: "Thoughts",
        html:
          '<p class="ge-tagline">Texts and discussions: notes, statements and fragments.</p>' +
          "<h4>Link</h4>" +
          "<ul>" +
          '<li><strong>Thoughts</strong> — <a href="' + LINKS.pensees + '" target="_blank" rel="noopener">' + UI.en.link_label + "</a></li>" +
          "</ul>"
      },
      es: {
        title: "Pensamientos",
        html:
          '<p class="ge-tagline">Textos y discusiones: notas, tomas de palabra y fragmentos.</p>' +
          "<h4>Enlace</h4>" +
          "<ul>" +
          '<li><strong>Pensamientos</strong> — <a href="' + LINKS.pensees + '" target="_blank" rel="noopener">' + UI.es.link_label + "</a></li>" +
          "</ul>"
      }
    }
  };

  // --- TwinLang Engine ---
  var STORAGE_KEY = "goody_ge_lang"; // si un jour tu veux forcer manuellement via setLang()

  function getLang() {
    // 1) si une langue a été forcée explicitement par setLang() => on la respecte
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return normLang(stored);
    } catch (_) {}
    // 2) sinon, follow navigateur / html lang
    return getDocLang();
  }

  function setLang(lang) {
    var l = normLang(lang);
    try { localStorage.setItem(STORAGE_KEY, l); } catch (_) {}
    applyLangEverywhere(l);
    return l;
  }

  function applyLangToBlock(root, lang) {
    var l = normLang(lang);
    lockAutoTranslate(root, l);

    // boutons
    var labels = (UI[l] && UI[l].buttons) ? UI[l].buttons : UI.fr.buttons;
    var btns = root.querySelectorAll("[data-ge-open]");
    for (var i = 0; i < btns.length; i++) {
      var key = btns[i].getAttribute("data-ge-open");
      if (labels[key]) btns[i].textContent = labels[key];
    }

    // fermer
    var closeBtn = root.querySelector("[data-ge-close]");
    if (closeBtn) closeBtn.textContent = (UI[l] && UI[l].close) ? UI[l].close : UI.fr.close;
  }

  function getContent(key, lang) {
    var l = normLang(lang || getLang());
    var pack = CONTENT[key];
    if (!pack) return null;
    return pack[l] || pack.fr || null;
  }

  function applyLangEverywhere(lang) {
    var l = normLang(lang);
    var blocks = document.querySelectorAll(".ge-scope[data-ge-instance]");
    for (var i = 0; i < blocks.length; i++) {
      applyLangToBlock(blocks[i], l);
    }
    // avertit le script du bloc (si un modal est ouvert, il pourra se rafraîchir)
    try {
      document.dispatchEvent(new CustomEvent("goody:ge:lang", { detail: { lang: l } }));
    } catch (_) {}
  }

  // --- Auto-sync navigateur ---
  var _lastApplied = null;
  function syncWithBrowser() {
    // Si localStorage contient une langue forcée, on ne sync pas.
    try {
      if (localStorage.getItem(STORAGE_KEY)) return;
    } catch (_) {}

    var l = getDocLang();
    if (l !== _lastApplied) {
      _lastApplied = l;
      applyLangEverywhere(l);
    }
  }

  function initAll() {
    var blocks = document.querySelectorAll(".ge-scope[data-ge-instance]");
    if (!blocks.length) return;

    var l = getLang();
    _lastApplied = l;

    for (var i = 0; i < blocks.length; i++) {
      // applique langue UI + no-translate
      applyLangToBlock(blocks[i], l);
    }
  }

  // --- Public API ---
  window.GoodyGETwinLang = {
    init: initAll,
    getLang: getLang,
    setLang: setLang,
    syncWithBrowser: syncWithBrowser,
    applyLangToBlock: applyLangToBlock,
    getContent: getContent
  };

  // Auto-init
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll();
      syncWithBrowser();
    }, { passive: true });
  } else {
    initAll();
    syncWithBrowser();
  }

  // "languagechange" (pas partout)
  try {
    window.addEventListener("languagechange", function () {
      syncWithBrowser();
    }, { passive: true });
  } catch (_) {}

  // Polling léger (évite les cas où rien ne remonte)
  // 1.5s = assez réactif sans surcharger
  setInterval(function () {
    syncWithBrowser();
  }, 1500);

})();
